// @givmo/design-system — the `data-testid` convention (CONVENTIONS, see README).
//
// Every interactive primitive accepts an optional `testId` prop and forwards it to its
// root interactive element as `data-testid`. This is the web replacement for Flutter's
// `flt-semantics-identifier` — it gives e2e (Playwright/RTL) and analytics a stable,
// implementation-independent selector that survives restyles and refactors.
//
// Usage in a component:
//   <button {...testIdProp(testId)} ... />
// Usage in a test/e2e:
//   screen.getByTestId('checkout-submit')  /  page.getByTestId('checkout-submit')

export interface TestIdProps {
  /** Stable selector forwarded as `data-testid` (replaces Flutter flt-semantics-identifier). */
  testId?: string;
}

/** Spread onto an element to forward a `data-testid` only when a value is provided. */
export function testIdProp(testId: string | undefined): { 'data-testid'?: string } {
  return testId === undefined ? {} : { 'data-testid': testId };
}
